import { PuckComponent } from '@measured/puck';
import { useMemo } from 'react';

import { IndicatorType } from '../blocks/molecules/indicators/create-indicators-config';
import { IndicatorContext } from '../context/indicators';

type RootProps = {
  children: React.ReactNode;
  indicators?: IndicatorType[];
  title: string;
};

const createRootRenderer = () => {
  const Root: PuckComponent<RootProps> = ({
    children,
    indicators = [],
    puck: {
      metadata: { respondents = [] },
    },
  }) => {
    const value = useMemo(
      () => ({
        allRespondents: new Set<string>(
          respondents.map(({ respondentType }: { respondentType: string }) => respondentType)
        ),
        indicators,
        respondents,
      }),
      [respondents, indicators]
    );

    return (
      <IndicatorContext.Provider value={value}>
        <div className="container py-2 lg:py-4 bg-neutral-100 h-full">{children}</div>
      </IndicatorContext.Provider>
    );
  };

  return Root;
};

export { createRootRenderer };

export type { RootProps };
